import { render, staticRenderFns } from "./BoardWriteFaqLayout.vue?vue&type=template&id=a4c0532e&scoped=true&"
import script from "./BoardWriteFaqLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteFaqLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c0532e",
  null
  
)

export default component.exports